import { Checkbox, Group, MantineSize, Text, Title } from '@mantine/core';
import { useSelectedObject } from '../../hooks/useSelectedObject';

type Size = MantineSize;

const sizes: Size[] = ['xl', 'lg', 'md', 'sm', 'xs'];

export const getSize = (value: number): Size => {
  const order = sizes[value];

  if (order === undefined) {
    return 'xs';
  }

  return order;
};

export const CardHeader = ({
  title,
  path,
  checked,
  required,
}: {
  title?: string;
  path?: string;
  checked: boolean;
  required: boolean;
}) => {
  const { updatedSelectedObjects } = useSelectedObject();

  return (
    <Group gap='xs' wrap='nowrap'>
      <Text fs='md'>{title}</Text>
      {required ? null : <Checkbox checked={checked} onChange={() => updatedSelectedObjects(path ?? '')} />}
    </Group>
  );
};
